// extracted by mini-css-extract-plugin
export default {"radio":"checkbox_radio__TR7I9","customRadio":"checkbox_customRadio__CLLNC","checked":"checkbox_checked__wBWvj","text":"checkbox_text__cgsNe","artOption":"checkbox_artOption__9p0fc"};